'use strict';

/**
 * sw-upload-model-modal
 *
 * This autohandler triggers the upload modal
 *
 * Usage:
 *
 * sw-upload-model-modal=<appId>
 *
 *   The model app id
 *
 *
 * Optional Params:
 *
 * sw-upload-model-modal-default-scale=<scale of the model>
 *
 *   The default scale for the model
 *
 * sw-upload-model-modal-default-tags=<model tags>
 *
 *   Tags for the model
 *
 * sw-upload-model-modal-upload-button-text=<button text>
 *
 *   Text for the upload button
 *
 * sw-upload-model-modal-subheading=<subheading>
 *
 *   Subheading for the modal
 *
 * sw-upload-model-modal-special-terms=<special terms>
 *
 *   Special Terms for the modal
 *
 * sw-upload-model-modal-source-page-id=<source page id>
 *
 *   Source page ID fro tracking
 *
 */

var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var notifications = require('js/lib/notifications/sw-notifications');

var UPLOAD_MODAL_CONSTANTS = {
  modalSelector:  '[data-sw-upload-modal]',
  endpointURL:    '/upload-modal',
  modalWidth:     '480px',
  modalEvents: {
    modalOpened:        'upload_modal_opened',
    modalNoData:        'upload_modal_no_data',
    modalRequestError:  'upload_modal_request_error',
    modalLaunched:      'upload_modal_launched'
  }
};

function bindUploadFormClick(){

  var $formbox = $('div.formbox');

  if($formbox.length) {
    if(!$formbox.hasClass('disabled') && $('#up3dfile').val()) {
      $.noty.closeAll();
      sw.notifications.dialog('', 'Please wait...', true, '400px', 'alphacube', {content: '<div class="sw--padding-2">Please wait while your model is being uploaded...  <div id="uploadWait" style="padding-top:20px; text-align:center;"></div></div>'});

      var $form = $formbox.children('form');
      $form.submit();
    }
  } else {
    $.noty.closeAll();
    sw.notifications.dialog('', 'Please wait...', true, '400px', 'alphacube', {content: '<div class="sw--padding-2">Please wait while your model is being uploaded...  <div id="uploadWait" style="padding-top:20px; text-align:center;"></div></div>'});
  }
}

function bindChangeFile() {
  var filename = $('#up3dfile').val();

  $('#filename').text(filename);
}

function signupUserForPromoEmailsSCTag(e)
{
  var $email = encodeURIComponent($('#mce-EMAIL2').val());
  var $skipOptIn = encodeURIComponent($('#mce-SKIP').val());
  var $data = 'email=' + $email + '&confirmation=footer' + '&tracking_type=footer' + '&skipDoubleOptIn=' + $skipOptIn + '&tracking_location=' + document.location.pathname;

  $.ajax({
    type:'POST',
    async: true,
    url: '/register/email-signup',
    data: $data,
    dataType: 'json',
    success: function(data) {
      if(data.response_status === 'failure') {
        notifications.error(data.response_text);
      } else {
        notifications.success(data.confirmation_content);
        $('#mce-EMAIL2').val('');
      }
    }
  });

  e.preventDefault();
  return false;
}


$(function() {
  var $body = $('body');
  $body.on('click', '#upload3DFileButton', bindUploadFormClick);
  $body.on('change', '#up3dfile', bindChangeFile);
  $body.on('click', '.upload3DFileTrigger', function () {
    $('#up3dfile').click(); return false;
  });

  $('#mc-embedded-subscribe-form2').off('submit').submit(signupUserForPromoEmailsSCTag);
});

$(function() {
  $('body').on('click', '[data-sw-upload-model-modal]', function(event) {
    event.preventDefault();

    var $el = $(this);
    var dataAttrs = $el.swDataParams('swUploadModelModal', { excludePrefix: true });

    sw.track(UPLOAD_MODAL_CONSTANTS.modalEvents.modalLaunched, {
      endpoint: UPLOAD_MODAL_CONSTANTS.endpointURL
    });

    $.ajax({
      type: 'GET',
      data: {
        appId:                dataAttrs.swUploadModelModal,
        defaultScale:         dataAttrs.defaultScale || '',
        tags:                 dataAttrs.tags || '',
        uploadButtonText:     dataAttrs.uploadButtonText || 'Upload',
        subheading:           dataAttrs.subheading || '',
        specialTerms:         dataAttrs.specialTerms || '',
        sourcePageIdentifier: dataAttrs.sourcePageId || '',
        sourcePageUrl: window.location.pathname
      },
      dataType: 'json',
      url: UPLOAD_MODAL_CONSTANTS.endpointURL,
      success:function (data) {
        var modalDisplayed = $(UPLOAD_MODAL_CONSTANTS.modalSelector).length;
        if(data.redirectUrl){
          window.location.assign(data.redirectUrl);
        }
        else if (!modalDisplayed) {
          if (data) {
            sw.notifications.dialog(data.content, 'Upload Your 3D Design', true, UPLOAD_MODAL_CONSTANTS.modalWidth, '', {closeWith: ['button', 'backdrop']});
          }
        }
      }
    });

  });
});
